'use client';

import { useEffect } from 'react';
import Script from 'next/script';

/**
 * Matomo Analytics mit CCM19 Consent-Koppelung
 * Lädt Matomo NUR wenn User Statistik-Cookies zugestimmt hat
 */
export function MatomoTracking() {
  useEffect(() => {
    // Warte auf CCM19 Consent-Entscheidung
    const checkConsent = () => {
      // CCM19 speichert Consent-Entscheidungen in window.CCM
      if (typeof window !== 'undefined' && window.CCM) {
        // Prüfe ob Matomo in den akzeptierten Embeddings ist
        // CCM19 speichert akzeptierte Tools als Array von Objekten
        const consentGiven = window.CCM.acceptedEmbeddings &&
                           window.CCM.acceptedEmbeddings.length > 0 &&
                           window.CCM.acceptedEmbeddings.some(tool =>
                             tool.name && tool.name.toLowerCase().includes('matomo')
                           );

        if (consentGiven) {
          initMatomo();
        }
      }
    };

    // Event-Listener für CCM19 Consent-Änderungen
    const handleConsentChange = () => {
      checkConsent();
    };

    // Warte bis CCM19 geladen ist
    const waitForCCM = setInterval(() => {
      if (window.CCM) {
        clearInterval(waitForCCM);
        checkConsent();
      }
    }, 100);

    // Höre auf Consent-Änderungen
    document.addEventListener('ccm19WidgetClosed', handleConsentChange);

    // Cleanup
    return () => {
      clearInterval(waitForCCM);
      document.removeEventListener('ccm19WidgetClosed', handleConsentChange);
    };
  }, []);

  const initMatomo = () => {
    // Initialisiere Matomo nur wenn noch nicht geladen
    if (window._paq) {
      console.log('Matomo bereits geladen');
      return;
    }

    // Matomo Tracking Code
    window._paq = window._paq || [];
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);

    (function() {
      const u = '//matomo.codeschnipsel.dev/';
      window._paq.push(['setTrackerUrl', u + 'matomo.php']);
      window._paq.push(['setSiteId', '1']);
      const d = document;
      const g = d.createElement('script');
      const s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = u + 'matomo.js';
      s.parentNode.insertBefore(g, s);
    })();

    console.log('Matomo initialisiert');
  };

  // Kein Script-Tag rendern, da wir dynamisch laden
  return null;
}

export default MatomoTracking;
